import { NgModule } from '@angular/core';
import { CommonModule as AngularCore } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import {
  ComponentsModule,
  PipesModule,
  PagePanelComponent,
  DataAnalyticsTaggingDirective,
  CallOutComponent,
  ToolbarComponent,
  ToolbarItemPrintComponent,
  ToolbarItemHelpComponent,
  ModalPanelComponent
} from '@tdwb/core';

// eslint-disable-next-line td-wb-rules/cross-lazyload-module-import-rule
import {
  LearnLessonInfoModule,
  LearnLoadingModule,
  LearnPlayerModule,
  LearnProgressBarModule,
  LearnProgressService,
  LearnToolbarPanelModule
} from '@tdwb/lazy/learn';
import { LearnSavedVideoModule } from './saved-lesson/learn-saved-video.module';
import { LearnDurationModule } from './duration/learn-duration.module';
import { LearnLessonContentComponent } from './content/learn-lesson-content.component';
import { TradingLearnModalComponent } from './trading/trading-learn-modal/trading-learn-modal.component';
import { TradingLearnRelatedLessonsComponent } from './trading/trading-learn-related-lessons/trading-learn-related-lessons.component';
import { TradingLearnInformationComponent } from './trading/trading-learn-information/trading-learn-information.component';
import { LearnRestService } from './learn-rest.service';

@NgModule({
  imports: [
    AngularCore,
    TranslateModule.forChild(),
    ComponentsModule,
    PipesModule,
    LearnPlayerModule,
    LearnLoadingModule,
    LearnProgressBarModule,
    LearnToolbarPanelModule,
    LearnLessonInfoModule,
    LearnSavedVideoModule,
    LearnDurationModule,
    PagePanelComponent,
    DataAnalyticsTaggingDirective,
    CallOutComponent,
    ToolbarComponent,
    ToolbarItemPrintComponent,
    ToolbarItemHelpComponent,
    ModalPanelComponent
  ],
  declarations: [
    LearnLessonContentComponent,
    TradingLearnModalComponent,
    TradingLearnRelatedLessonsComponent,
    TradingLearnInformationComponent
  ],
  exports: [
    LearnLessonContentComponent,
    TradingLearnModalComponent,
    TradingLearnRelatedLessonsComponent,
    TradingLearnInformationComponent,
    LearnSavedVideoModule,
    LearnDurationModule
  ],
  providers: [
    LearnRestService,
    LearnProgressService
  ]
})
export class WebbrokerLearnCommonModule {
}

export {
  LearnLessonContentComponent,
  TradingLearnModalComponent,
  TradingLearnRelatedLessonsComponent,
  TradingLearnInformationComponent,
  LearnRestService,
  LearnSavedVideoModule,
  LearnDurationModule
};
